module.exports = __webpack_public_path__ + "static/headshot-mitchell-grenier-3x.19e3a0b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/headshot-mitchell-grenier-3x.jpg
// module id = 133
// module chunks = 35783957827783 152909308826437